<template>
	<Loader />
	<router-view></router-view>
	<SuccessModal v-model="showSuccessModal" :message="successMessage" />
	<ErrorModal v-model="showErrorModal" :error-message="errorMessage" :test-mode="testMode" />
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import { useStore } from 'vuex'
import Loader from '@/components/Loader.vue'
import SuccessModal from '@/components/SuccessModal.vue'
import ErrorModal from '@/components/ErrorModal.vue'

const store = useStore()

const successMessage = computed(() => store.state.notification.successMessage || '')
const showSuccessModal = computed(() => store.state.notification.showSuccessModal)

const showErrorModal = computed({
	get: () => store.state.notification.showErrorModal,
	set: value => store.commit('notification/SET_SHOW_ERROR_MODAL', value)
})

const errorMessage = computed(() => store.state.notification.errorMessage || [])
const testMode = computed(() => store.getters.isTestMode)

watch(showSuccessModal, () => {
	if (showSuccessModal.value) {
		store.dispatch('notification/hideSuccess')
	}
})
</script>
